<template>
	<UnorderedList :icon-top="iconTop" v-bind="$attrs">
		<template v-for="(index, name) in $slots" #[name]>
			<slot :name="name" />
		</template>
		<template #icon>
			<IconTick class="h-auto w-4" :class="iconColor" />
		</template>
	</UnorderedList>
</template>

<script setup>
import UnorderedList from '@/components/lists/UnorderedList.vue'
import IconTick from '@/assets/svg/common/ico-tick.svg'

const props = defineProps({
	iconTop: {
		type: String,
		required: false,
		default: 'top-1.5',
	},
	iconColor: {
		type: String,
		required: false,
		default: 'text-orange-400',
	},
})
</script>
